import removeAccents from 'vn-remove-accents'

const removeActions = (string) => removeAccents(string)

export default removeActions
